module.exports = __webpack_public_path__ + "static/media/ophos-hardware.6e1bb708.svg";